<template>

  <div>
    <div v-if="mostrarForm">
      <empleados-form-component :original="datosForm" @_cancelarEditar="cancelarEditar"
                                    :optionsCliente="optionsCliente"></empleados-form-component>
    </div>
    <div v-if="mostrarPerfilesForm">
      <empleados-perfiles-form-component :original="datosForm" @_cancelarEditar="cancelarEditar"
                                :optionsCliente="optionsCliente"></empleados-perfiles-form-component>
    </div>
    <div v-if="!mostrarForm && !mostrarPerfilesForm">
      <aside class="bg-primary bg-gradient rounded-1 p-0 p-sm-1 mt-1">
        <div
            class="d-flex align-items-center justify-content-between flex-column flex-xl-row text-center text-xl-start">
          <div class="mb-4 mb-xl-0">
            <div class="fs-3 fw-bold text-white">Empleados</div>
            <div class="text-white-50">En ésta sección podrás administrar los empleados</div>
          </div>
          <div class="mb-4 mb-xl-0">
            <div class="row">
              <div class="col">
                <button type="button" class="btn btn-success btn-sm"
                        @click="editar(null)">
                  <FontAwesomeIcon :icon="faPlus()"/>
                  Agregar Empleado
                </button>
              </div>
            </div>
          </div>
        </div>
      </aside>

      <div class="container px-lg-3 px-xl-2 px-xxl-2 mt-2">
        <div class="row ">

          <div class="col-4">
            <div class="input-group">
              <span class="input-group-text">Cliente</span>
              <input v-model="filtros.nombre_cliente"
                     style="float: right;"
                     class="form-control"
                     placeholder="Nombre del cliente"
                     @keydown.prevent.enter="obtener()"
              />
              <button type="button" class="input-group-text" style="float: right;" @click="filtros.nombre_cliente=null"
                      v-if="filtros.nombre_cliente!=null">
                <FontAwesomeIcon :icon="faClose()" title="Restablecer nombre del cliente"/>
              </button>
            </div>
          </div>
          <div class="col-4">
            <div class="input-group">
              <span class="input-group-text">Sucursal</span>
              <input v-model="filtros.nombre_sucursal"
                     style="float: right;"
                     class="form-control"
                     placeholder="Nombre de la sucursal"
                     @keydown.prevent.enter="obtener()"
              />
              <button type="button" class="input-group-text" style="float: right;" @click="filtros.nombre_sucursal=null"
                      v-if="filtros.nombre_sucursal!=null">
                <FontAwesomeIcon :icon="faClose()" title="Restablecer nombre de la sucursal"/>
              </button>
            </div>
          </div>
          <div class="col-4">
            <div class="input-group">
              <span class="input-group-text">Área</span>
              <input v-model="filtros.nombre_area_sucursal"
                     style="float: right;"
                     class="form-control"
                     placeholder="Nombre del área"
                     @keydown.prevent.enter="obtener()"
              />
              <button type="button" class="input-group-text" style="float: right;" @click="filtros.nombre_area_sucursal=null"
                      v-if="filtros.nombre_area_sucursal!=null">
                <FontAwesomeIcon :icon="faClose()" title="Restablecer nombre del área"/>
              </button>
            </div>
          </div>
          <div class="col-4 mt-2">
            <div class="input-group">
              <span class="input-group-text">Turno</span>
              <input v-model="filtros.nombre_turno"
                     style="float: right;"
                     class="form-control"
                     placeholder="Turno"
                     @keydown.prevent.enter="obtener()"
              />
              <button type="button" class="input-group-text" style="float: right;" @click="filtros.nombre_turno=null"
                      v-if="filtros.nombre_turno!=null">
                <FontAwesomeIcon :icon="faClose()" title="Restablecer nombre del turno"/>
              </button>
            </div>
          </div>
          <div class="col-4 mt-2">
            <div class="input-group">
              <span class="input-group-text">Empleado</span>
              <input v-model="filtros.nombre_empleado"
                     style="float: right;"
                     class="form-control"
                     placeholder="Nombre del empleado"
                     @keydown.prevent.enter="obtener()"
              />
              <button type="button" class="input-group-text" style="float: right;" @click="filtros.nombre_empleado=null"
                      v-if="filtros.nombre_empleado!=null">
                <FontAwesomeIcon :icon="faClose()" title="Restablecer nombre del empleado"/>
              </button>
            </div>
          </div>
          <div class="col-12">
            <button type="button" class="btn btn-success" style="float: right;" @click="obtener()">
              <FontAwesomeIcon :icon="faSearch()"/>
              Buscar
            </button>
          </div>

        </div>
      </div>

      <div class="container">
        <div class="row m-4">
          <div class="col" align="right">

          </div>
        </div>
        <div class="row">
          <div>Solo se mostraran 200 registros max por consulta</div>
          <div class="table-responsive" style="height: 400px">
            <table class="table table-striped table-light table-border">
              <thead>
                <tr>
                  <th width="10%" class="header" scope="col" rowspan="2"># Empleado</th>
                  <th width="20%" class="header" scope="col" rowspan="2">Nombre completo</th>
                  <th width="10%" class="header" scope="col" rowspan="2">Correo</th>
                  <th width="45%" class="header" scope="col" colspan="4" style="text-align: center">Lugares de trabajo</th>
                  <th width="15%" class="header" scope="col" rowspan="2">Acciones</th>
                </tr>
                <tr>
                  <th width="45%" class="header1" scope="col" colspan="4" >
                    <table style="width: 100%">
                      <thead>
                        <tr>
                          <th width="25%" class="header1" scope="col">Cliente</th>
                          <th width="25%" class="header1" scope="col">Sucursal</th>
                          <th width="25%" class="header1" scope="col">Área</th>
                          <th width="25%" class="header1" scope="col">Turno</th>
                        </tr>
                      </thead>
                    </table>
                  </th>
                </tr>
              </thead>
              <tbody>
              <template v-for="item in datos_tabla" v-bind:key="item.id">
                <tr>
                  <th scope="row">{{ item.numero_empleado }}</th>
                  <th scope="row">{{ item.nombre_empleado }}</th>
                  <th scope="row">{{ item.correo_empleado }}</th>
                  <th scope="row" colspan="4">
                    <table style="width: 100%">
                      <tr v-for="lugar in item.lugares_trabajo" :key="lugar">
                        <th width="25%" scope="row" v-for="dlugar in lugar" :key="dlugar">
                          {{dlugar}}
                        </th>
                      </tr>
                    </table>
                  </th>
                  <th scope="row">
                    <button v-if="item.registroActivo" class="btn btn-danger m-1"
                            @click="activarDesactivar(item.id)" title="Desactivar">
                      <FontAwesomeIcon :icon="faDesActivar()"/>
                    </button>
                    <button v-else class="btn btn-secondary m-1" @click="activarDesactivar(item.id)" title="Re-Activar">
                      <FontAwesomeIcon :icon="faActivar()"/>
                    </button>
                    <button class="btn btn-warning m-1" @click="editar(item)" title="Editar">
                      <FontAwesomeIcon :icon="faEditar()"/>
                    </button>
                    <button class="btn btn-info m-1" @click="editarPerfiles(item)" title="Perfiles"
                            v-if="$localStorageService.can('api.ADM_EMPLEADO_PERFILES')">
                      <FontAwesomeIcon :icon="faEditar()"/>
                    </button>
                  </th>
                </tr>
              </template>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

  </div>

</template>

<script>

import {inject} from "vue";
import {faClose, faEdit, faPlus, faRedo, faSearch, faTrash} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
import {ClienteService} from "@/services/ClienteService";
import EmpleadosFormComponent from "@/views/EmpleadosForm-Component.vue";
import {EmpleadoService} from "@/services/EmpleadoService";
import EmpleadosPerfilesFormComponent from "@/views/EmpleadosPerfilesForm-Component.vue";

export default {
  name: 'Area-Sucursal-Component',
  components: {
    EmpleadosPerfilesFormComponent,
    EmpleadosFormComponent,
    FontAwesomeIcon
  },
  inject: ['$axios', '$localStorageService'],
  setup() {
    return {
      srv_ClienteService: new ClienteService(inject('$axios')),
      srv_EmpleadoCatService: new EmpleadoService(inject('$axios'))
    }
  },
  props: {},
  data() {
    return {
      filtros: {
        nombre_area_sucursal: null,
        nombre_sucursal: null,
        nombre_cliente: null,
        nombre_turno: null
      },
      datos_tabla: [],
      id: null,

      mostrarForm: false,
      mostrarPerfilesForm: false,
      datosForm: null,
      optionsCliente: [],
    }
  },
  async mounted() {
    await this.obtener();
    await this.obtenerClientes();
  },
  methods: {
    faPlus() {
      return faPlus;
    },
    faSearch() {
      return faSearch;
    },
    faClose() {
      return faClose;
    },
    faActivar() {
      return faRedo;
    },
    faDesActivar() {
      return faTrash;
    },
    faEditar() {
      return faEdit;
    },
    async obtener() {

      let load = this.$loading.show({
        container: this.$refs.formContainer,//puede ponerse null
        canCancel: false,
        onCancel: this.onCancelLoader,
      });

      this.datos_tabla = [];
      await this.srv_EmpleadoCatService.obtener(this.filtros).then((response) => {
        this.datos_tabla = response;

        this.datos_tabla.forEach(it=>{
          const detLugares = JSON.parse(JSON.stringify(it.lugares_trabajo.split("||")));

          it.lugares_trabajo = []
          detLugares.forEach(it1=>{
            it.lugares_trabajo.push(it1.split("|"));
          })
        })
        console.info("------", this.datos_tabla.lugares_trabajo);
      }).catch((error) => {
        console.error(error)
        this.$swal(error.message);
      }).finally(() => load.hide());
    },
    async activarDesactivar(num) {
      let load = this.$loading.show({
        container: this.$refs.formContainer,//puede ponerse null
        canCancel: false,
        onCancel: this.onCancelLoader,
      });
      await this.srv_EmpleadoCatService.activarInactivar(num).then(() => {
      }).catch((error) => {
        console.error(error)
        this.$swal(error.message);
      }).finally(() => {
        load.hide();
        this.obtener();
      });
    },
    editar(data) {
      this.mostrarForm = true;
      this.datosForm = data;
    },
    editarPerfiles(data) {
      this.mostrarPerfilesForm = true;
      this.datosForm = data;
    } ,
    cancelarEditar() {
      this.mostrarForm = false;
      this.mostrarPerfilesForm = false;
      this.datosForm = null;
      this.obtener();
    },

    async obtenerClientes() {

      let load = this.$loading.show({
        container: this.$refs.formContainer,//puede ponerse null
        canCancel: false,
        onCancel: this.onCancelLoader,
      });

      this.optionsCliente = [];
      await this.srv_ClienteService.obtener({registro_activo: true}).then((response) => {
        this.optionsCliente = response;
      }).catch((error) => {
        console.error(error)
        this.$swal(error.message);
      }).finally(() => load.hide());
    },
  }
}
</script>

<style scoped>
.header {
  position: sticky;
  top: 0;
}
.header1 {
  position: sticky;
  top: 39px;
}
</style>